import { Link } from 'react-router-dom';
import React from 'react';
import { clientColumnSorter } from '../../utils/tableClientSort';

export const meterAnalysisDashboardTableHeaders = [
  {
    title: 'No',
    dataIndex: 'key',
    sorter: clientColumnSorter('key'),
  },
  {
    title: 'Date',
    dataIndex: 'date',
    sorter: clientColumnSorter('date'),
  },
  {
    title: 'Online',
    dataIndex: 'onlineCount',
    sorter: clientColumnSorter('onlineCount'),
  },
  {
    title: 'Online (%)',
    dataIndex: 'onlinePercentage',
    sorter: clientColumnSorter('onlinePercentage'),
  },
  {
    title: 'Offline',
    dataIndex: 'offlineCount',
    sorter: clientColumnSorter('offlineCount'),
  },
  {
    title: 'Offline (%)',
    dataIndex: 'offlinePercentage',
    sorter: clientColumnSorter('offlinePercentage'),
  },
  {
    title: 'Alarms',
    dataIndex: 'alarmCount',
    sorter: clientColumnSorter('alarmCount'),
  },
];

export const alarmAnalysisTableHeaders = [
  {
    title: 'Meter ID',
    dataIndex: 'serialNumber',
    sorter: clientColumnSorter('serialNumber'),
    render: (text, record) => {
      return (
        <>
          <Link to={`individual-analysis/${record?.serialNumber}`}>
            <p className="text-dark-blue-100">{text}</p>
          </Link>
        </>
      );
    },
  },
  {
    title: 'Low Battery',
    dataIndex: 'Battery',
    sorter: clientColumnSorter('Battery'),
  },
  {
    title: 'Low Flow',
    dataIndex: 'Low Flow',
    sorter: clientColumnSorter('Low Flow'),
  },
  {
    title: 'High Flow',
    dataIndex: 'High Flow',
    sorter: clientColumnSorter('High Flow'),
  },
  {
    title: 'Component Fault',
    dataIndex: 'Component Fault',
    sorter: clientColumnSorter('Component Fault'),
  },

  {
    title: 'Dry',
    dataIndex: 'Dry',
    sorter: clientColumnSorter('Dry'),
  },
  {
    title: 'Burst',
    dataIndex: 'Burst',
    sorter: clientColumnSorter('Burst'),
  },
  {
    title: 'Reverse Flow',
    dataIndex: 'Reverse Flow',
    sorter: clientColumnSorter('Reverse Flow'),
  },
  {
    title: 'EEPROM',
    dataIndex: 'EEPROM',
    sorter: clientColumnSorter('EEPROM'),
  },
  {
    title: 'High Temperature',
    dataIndex: 'High Temp',
    sorter: clientColumnSorter('High Temp'),
  },
  {
    title: 'Others',
    dataIndex: 'Others',
    sorter: clientColumnSorter('Others'),
  },
];

export const transmissionAnalysisTableHeaders = [
  {
    title: 'Serial Number',
    dataIndex: 'serialNumber',
    width: '30%',
    sorter: clientColumnSorter('serialNumber'),
    render: (text) => {
      return (
        <>
          <Link to="">
            <p className="text-dark-blue-100">{text}</p>
          </Link>
        </>
      );
    },
  },
  {
    title: 'Online',
    dataIndex: 'onlineDayCount',
    sorter: clientColumnSorter('onlineDayCount'),
  },
  {
    title: 'Offline',
    dataIndex: 'offlineDayCount',
    sorter: clientColumnSorter('offlineDayCount'),
  },
  {
    title: '3 Days > Offline',
    dataIndex: 'moreThan3DaysOffline',
    sorter: clientColumnSorter('moreThan3DaysOffline'),
  },
];

export const consumptionAnalysisTableHeaders = [
  {
    title: 'Date',
    dataIndex: 'date',
    sorter: clientColumnSorter('date'),
  },
  {
    title: 'Daily Total (m3)',
    dataIndex: 'm3',
    sorter: clientColumnSorter('m3'),
  },
  {
    title: 'DAVC',
    dataIndex: 'davc',
    sorter: clientColumnSorter('davc'),
  },
  {
    title: 'consumptionDrop',
    dataIndex: 'consumptionDropInPercentage',
    sorter: clientColumnSorter('consumptionDropInPercentage'),
  },
];

export const flowAnalysisTableHeaders = [
  {
    title: '<0',
    dataIndex: 'below0',
    sorter: clientColumnSorter('below0'),
  },
  {
    title: 'Q1',
    dataIndex: 'q1',
    sorter: clientColumnSorter('q1'),
  },
  {
    title: 'Q2',
    dataIndex: 'q2',
    sorter: clientColumnSorter('q2'),
  },
  {
    title: 'Q3',
    dataIndex: 'q3',
    sorter: clientColumnSorter('q3'),
  },
  {
    title: 'Q4',
    dataIndex: 'q4',
    sorter: clientColumnSorter('q4'),
  },
  {
    title: '> Q4',
    dataIndex: 'aboveQ4',
    sorter: clientColumnSorter('aboveQ4'),
  },
];

export const alarmChartOptions = {
  options: {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: [
      '#6EC3E2',
      '#A2D149',
      '#40A4B8',
      '#F5F5DC',
      '#4DA0CF',
      '#8F9A68',
      '#C2E7A9',
      '#FFB380',
      '#808080',
    ],
    stroke: {
      width: 5,
      // colors: ["#fff"],
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        stacked: true,
        columnWidth: '8%',
      },
    },
    xaxis: {
      labels: {
        rotate: -45,
      },
      type: 'datetime',
    },
    fill: {
      opacity: 1,
    },
    yaxis: {
      labels: {
        formatter: (val) => {
          return val;
        },
      },
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
    },
    animations: {
      enabled: false,
      dynamicAnimation: {
        enabled: false,
      },
    },
  },
};

export const transmissionChartOptions = {
  series: [
    {
      name: 'Offline',
      type: 'column',
      data: [14, 15, 14, 26, 22, 14, 12, 13, 17, 23, 12, 1],
    },
    {
      name: '3 Days Offline',
      type: 'line',
      data: [99, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16],
    },
  ],
  options: {
    chart: {
      height: 350,
      type: 'line',
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      width: [0, 4],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },
    labels: [
      '01 Jan 2001',
      '02 Jan 2001',
      '03 Jan 2001',
      '04 Jan 2001',
      '05 Jan 2001',
      '06 Jan 2001',
      '07 Jan 2001',
      '08 Jan 2001',
      '09 Jan 2001',
      '10 Jan 2001',
      '11 Jan 2001',
      '12 Jan 2001',
    ],
    yaxis: [
      {
        opposite: true,
      },
    ],
  },
};

export const consumptionChartOptions = {
  options: {
    chart: {
      height: 350,
      type: 'line',
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      width: [0, 4],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },
    labels: [
      '01 Jan 2001',
      '02 Jan 2001',
      '03 Jan 2001',
      '04 Jan 2001',
      '05 Jan 2001',
      '06 Jan 2001',
      '07 Jan 2001',
      '08 Jan 2001',
      '09 Jan 2001',
      '10 Jan 2001',
      '11 Jan 2001',
      '12 Jan 2001',
    ],
    yaxis: [
      {
        opposite: true,
      },
    ],
  },
};

export const flowChartOptions = {
  options: {
    chart: {
      height: 350,
      type: 'scatter',
      zoom: {
        enabled: false,
        // type: 'xy'
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    xaxis: {
      tickAmount: 10,
      labels: {
        formatter: function (val) {
          return parseFloat(val).toFixed(1);
        },
      },
    },
    yaxis: {
      tickAmount: 7,
    },
  },
};

export const CHART_NODATA_CONSTANT = {
  noData: {
    text: 'An Error Occurred...',
    style: {
      fontSize: '28px',
    },
  },
};

export const SEARCHABLE_ANALYSIS_TYPES = ['alarm', 'transmission'];
